import React from "react";
import { useNavigate, Link } from "react-router-dom";

// Only allow same-site absolute paths as post-auth redirect targets (prevents open redirects).
export function safeInternalPath(p, fallback = "/dashboard") {
  if (typeof p !== "string" || !p) return fallback;
  if (!p.startsWith("/") || p.startsWith("//")) return fallback;
  if (p.includes("://") || p.includes("\\")) return fallback;
  return p;
}

export function GoogleButton({ label = "Continue with Google", next }) {
  const onClick = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/?next=" + encodeURIComponent(safeInternalPath(next));
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button type="button" onClick={onClick} data-testid="google-login-button"
      className="flex w-full items-center justify-center gap-3 rounded-xl border border-border bg-white px-4 py-3 font-semibold text-[#2D1E18] shadow-sm hover:bg-secondary">
      <svg width="20" height="20" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.4 29.3 35.5 24 35.5c-6.3 0-11.5-5.1-11.5-11.5S17.7 12.5 24 12.5c2.9 0 5.6 1.1 7.6 2.9l5.7-5.7C33.6 6.5 29 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5 43.5 34.8 43.5 24c0-1.2-.1-2.3-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12.5 24 12.5c2.9 0 5.6 1.1 7.6 2.9l5.7-5.7C33.6 6.5 29 4.5 24 4.5c-7.2 0-13.4 4-16.7 10.2z"/><path fill="#4CAF50" d="M24 43.5c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.5-4.5 2.4-7.2 2.4-5.3 0-9.7-3.1-11.3-7.5l-6.5 5C9.6 39.5 16.2 43.5 24 43.5z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4.1 5.5l6.2 5.2c-.4.4 6.6-4.8 6.6-14.7 0-1.2-.1-2.3-.4-3.5z"/></svg>
      {label}
    </button>
  );
}

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="mx-auto flex min-h-[70vh] max-w-md flex-col justify-center px-4 py-12">
      <div className="text-center">
        <Link to="/"><img src="/logo.png" alt="Lawley Village Line Dance Club" className="mx-auto h-24 w-auto" /></Link>
        <h1 className="mt-4 font-display text-2xl font-extrabold text-[#2D1E18]">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-[#5C4A42]">{subtitle}</p>}
      </div>
      <div className="mt-8 rounded-2xl border border-border bg-card p-6 shadow-sm">{children}</div>
      {footer && <div className="mt-5 text-center text-sm text-[#5C4A42]">{footer}</div>}
    </div>
  );
}

export function Field({ label, error, children }) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-sm font-semibold text-[#2D1E18]">{label}</span>
      {children}
      {error && <span className="mt-1 block text-xs font-semibold text-[#991B1B]">{error}</span>}
    </label>
  );
}

export const inputClass = "w-full rounded-xl border border-border bg-white px-3.5 py-2.5 text-[#2D1E18] outline-none focus:border-[#C85A32]";
export { useNavigate };
